export const EMPTY_ARRAY = Object.freeze([]);
//# sourceMappingURL=emptyArray.js.map